/**
 * Created by alex.y on 7/19/2017.
 */
import {Injectable} from "@angular/core";
import {CurrencyItem} from "../../objects/currencyExchange/currencyItem";
import {Resolve} from "@angular/router";
import {CurrencyService} from "../../services/currencyService";

@Injectable()
export class CurrencyResolver implements Resolve<Array<CurrencyItem>> {

    constructor(private currencyService: CurrencyService) {
    }

    public resolve(): Promise<Array<CurrencyItem>> {

        let date: Date = new Date(Date.now());
        date.setDate(date.getDate() - 356);

        return this.currencyService.getFromDate(date).then(result => {
            return result.Data;
        }).catch(err => {
            //TODO how we will handle errors in js?
            return null;
        });
    }
}


// WEBPACK FOOTER //
// ./app/components/currencyExchange/currency.resolver.ts